import { defineComponent as _defineComponent } from 'vue'
import { ContactFilter, ContactHealthStatus } from '@/types';
import { useI18n } from 'vue-i18n';

interface HealthFilterOption {
    label: string;
    value: ContactHealthStatus | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactListFilters',
  props: {
    modelValue: { type: Object, required: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const { t } = useI18n();



const emit = __emit;

const filters: HealthFilterOption[] = [
    { label: t('core.options.All'), value: null },
    { label: t('contact.timeline.stats.healthScore.healthy'), value: ContactHealthStatus.HEALTHY },
    {
        label: t('contact.timeline.stats.healthScore.attention'),
        value: ContactHealthStatus.ATTENTION,
    },
    { label: t('contact.timeline.stats.healthScore.atRisk'), value: ContactHealthStatus.AT_RISK },
];

const selectFilter = (health: ContactHealthStatus | null) => {
    emit('update:modelValue', { health });
};

const __returned__ = { t, emit, filters, selectFilter }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})